import { render, staticRenderFns } from "./StoreFaq.vue?vue&type=template&id=61b6acba&scoped=true"
import script from "./StoreFaq.vue?vue&type=script&lang=js"
export * from "./StoreFaq.vue?vue&type=script&lang=js"
import style0 from "./StoreFaq.vue?vue&type=style&index=0&id=61b6acba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6acba",
  null
  
)

export default component.exports